import React from 'react'
import MaterialSymbol from '../material-symbol'

const Place = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="place" {...props} />
))

Place.displayName = 'Place'

export default Place
